// AccountModal — lightweight dark-glass overlay opened from the navbar for a
// signed-in user. Currently hosts the biometric (passkey) setting; a natural
// home for future account controls.
import React, { useEffect } from 'react';
import BiometricLoginToggle from './BiometricLoginToggle';
import './AccountModal.css';

const AccountModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="account-modal__backdrop" onClick={onClose}>
      <div
        className="account-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Account settings"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="account-modal__header">
          <h2 className="account-modal__title">Account</h2>
          <button
            type="button"
            className="account-modal__close"
            aria-label="Close"
            onClick={onClose}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        <div className="account-modal__body">
          <BiometricLoginToggle />
        </div>
      </div>
    </div>
  );
};

export default AccountModal;
